import { c as _c } from "react/compiler-runtime";
import { operations } from './generated/selfCare';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { useQuery } from '@tanstack/react-query';
export type PublicInstallmentsCalculatorResponse = operations['publicInstallmentsCalculator']['responses']['200']['content']['application/json'] | undefined;
export type Params = operations['publicInstallmentsCalculator']['parameters']['query'];
export function useInstallmentsCalculator(params, options) {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = QUERY_KEYS.publicInstallments(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = async () => {
      const res = await apiSelfCareFetcher(URLS.publicInstallmentsCalculator, {
        searchParams: {
          principal: params.principal
        }
      });
      if (!res.json) {
        throw new Error("No data returned");
      }
      return res.json;
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
}